import { useState } from "react";
import { IRegion } from "../../../types/contacts";
import { ChatTags } from "./ChatTags";

interface RegionProps {
  regions: IRegion[];
  selectedRegionId: number;
  onSelectRegion: (idRegion: number) => void;
}

const SelectRegion = ({ regions, selectedRegionId, onSelectRegion }: RegionProps) => {

  return (

    <div className="d-flex align-items-end w-100 pb-2">
      <div className="flex-grow-1">
        <select
          value={selectedRegionId}
          className="form-select form-select-md form-control bg-light border-0 pe-0"
          onChange={(e) => onSelectRegion(Number(e.target.value))}
        >
          {regions.map((opt) => (
            <option key={opt.idRegiao} value={opt.idRegiao}>
              {opt.nome}
            </option>
          ))}
        </select>
      </div>
    </div>


  );
};

export default SelectRegion;
